import type { ComponentChildren } from "preact";
import { ScrollToTop } from "../components/ScrollToTop";
import { useIsSignedIn } from "../platform/session";
import { DesktopNav } from "./DesktopNav";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { MobileNav } from "./MobileNav";
import { navClasses } from "./navClasses";

type RootProps = {
  path: string;
  children: ComponentChildren;
};

/** The element every page sits in: it says whether there is a session and which nav item is active (see site.css). */
export const SiteRoot = ({ path, children }: RootProps) => {
  const session = useIsSignedIn() ? "signedin" : "anonymous";
  return <div class={`site-layout ${session} ${navClasses(path)} relative min-h-screen bg-neutral-50 dark:bg-neutral-900`}>{children}</div>;
};

/** The page chrome: desktop side nav, mobile header and tab bar, footer. */
export const Layout = ({ path, children }: RootProps) => (
  <SiteRoot path={path}>
    <DesktopNav />
    <div class="max-w-lg mx-auto w-full">
      <Header />
      <main class="pt-18 lg:pt-8 pb-12 px-2 min-h-screen">{children}</main>
      <Footer />
      <MobileNav />
    </div>
    <ScrollToTop />
  </SiteRoot>
);
